import {React, extend, omnitureTrack, joinUrl, _n, getInitHierarchy} from 'pexui';
import get from 'lodash/get';
import {flow, getTrackLabel} from '../models/flow';
import globals from '../models/globals';
import * as utils from '../utilities/utils';
import * as dtm from './dtm';
import {
  SUCCESSFUL_FIRST_LOAD_EVENT,
  SUCCESSFUL_COMPLETED_JOURNEY_EVENT,
  DTM,
  ITAG,
  ONE_AMEX_DDL,
  ONE_APP_DDL_TRACKING
} from '../models/consts';
import { mapErrorKeyToErrorTag } from './errorTagging';
import { mapSuccessKeyToTag } from './successTagging';

var trackMethod = '';
var trackMarket = 'IN';
var lastOmn = {};
var initReq;

export function initTrack(config, req){
    trackMarket = req.market;
    initReq = req;
    updateTrackMethod();
    globals.omnInvokerId = req.originator_id;
}

// postponed initialization (in eapply case, objects may be available after a while)
const updateTrackMethod = () => {
  if(!trackMethod){
    const req = getReq();

    if (get(flow, 'widgetConfig.analytics.analyticsClick')){
      return trackMethod = ONE_AMEX_DDL;
    }
    if (get(flow, 'widgetConfig.analytics_ddl_callback')){
      return trackMethod = ONE_APP_DDL_TRACKING;
    }
    if(req.market === 'IN'){
      return trackMethod = ITAG;
    }
    if(dtm.hasDtm() || req.originator_id.indexOf('DXP') >= 0){
      return trackMethod = DTM;
    }
    if(typeof(s)==='object' && s){
      return trackMethod = ITAG;
    }
  }
}

export function setTrackOpts(pagename, opts){
    lastOmn = makeTagObject(pagename, opts);
}

export const getIsDtm = () => trackMethod === DTM;

const getReq = () => flow.req || initReq;

export const getQuestionNumber = (node) => `Q${Math.max(flow.getNodeIndex(node) + 1, 1)}`;

const getCapability = () => {
  const options = flow.getCurrentNode().widgetOption.docOptions;
  if (options.length > 1) {
    return 'Options';
  }
  return options[0];
}

const getMultiSingle = (arr) => arr.length > 1 ? 'Multi' : 'Single';

const getCapabilityFlow = () => flow.currLevelNodes.map(
  node => get(node, 'widgetOption.docOptions')
    ? node.widgetOption.docOptions.join('-')
    : 'NULL'
).join(':');

const getPageName = (event, currentPage) => {
  const pageNameBase = `Widget:GI:${getQuestionNumber(flow.getCurrentNode())}`;
  if (event === SUCCESSFUL_COMPLETED_JOURNEY_EVENT) {
    return `${pageNameBase}:${getCapability()}:${currentPage}`;
  }

  if (currentPage) {
    return `${pageNameBase}:${currentPage}`;
  }

  //successfully loaded page, accordion clicks
  return `${pageNameBase}:${getCapability()}`;
}

const getTools = (bankName, successStatus) => {
  const bankNameString = bankName ? `:BankName-${bankName}` : '';
  const questionsWithDetails = successStatus
    ? mapSuccessKeyToTag(successStatus)
    : flow.nodes
        .map(node => `${getQuestionNumber(node)}-${getTrackLabel(node)}`)
        .join(':');
  return `${getMarket()}:GI:${questionsWithDetails}${bankNameString}`
}

const getProducts = () => `${getMarket()}:${getBusinessUnit()}:${getPmc()}`;

const getMarket = () => {
  const products = get(window.s, 'products', '');

  return products.split(':')[0] || `${trackMarket}`;
};

const getBusinessUnit = () => {
  const products = get(window.s, 'products', '');
  const productsBusinessUnitCode = products.split(':')[1];
  const documentDataBusinessUnitCode = getReq().document_data.business_unit_code;

  return productsBusinessUnitCode || documentDataBusinessUnitCode;
}

const getPmc = () => {
  const req = getReq();
  const products = get(window.s, 'products', '');
  const pmc = products.split(':')[2]

  return pmc || req.originator_id;
};

const getFlowType = () => {
  const question = getMultiSingle(flow.widgetOptions);
  const capability = getMultiSingle(flow.allDocOptions);

  return `${question}Q-${capability}C`;
}

const getId = () => `${getMarket()}:GI:${getBusinessUnit()}:${getFlowType()}:${getCapabilityFlow()}`;

const getCurrencyCode = () => get(window.s, 'currencyCode') || getMarket();

const getLocale = () => get(flow, 'config.invoker_locale');

const getConversionStep = (e) => {
  switch(e) {
    case SUCCESSFUL_FIRST_LOAD_EVENT:
      return 'selfservicestart';
    case SUCCESSFUL_COMPLETED_JOURNEY_EVENT:
      return 'selfservicecomplete';
    default:
      return '';
  }
}

export function createOMNObject(pagename, opts = {}){
    const req = getReq();
    const market = getMarket();
    const pmc = getPmc() || req.originator_id;
    const productID = get(window, 's.contextData["omn.productID"]', '');
    const productIDParts = productID.split(':');

    let invokerId = req.originator_id;
    let events = opts.events;
    let bankName = opts.bankName;
    let customerType = 'Customer';

    if (productIDParts.length >= 2) {
        invokerId = productIDParts[1];
    } else {
        invokerId = 'ICSS';
    }

    globals.omnInvokerId = invokerId;


    if (req.document_data.business_unit_code === 'OPEN') {
        if (req.is_small_business) {
            customerType = 'SBS';
        } else {
            customerType = 'Corporate';
        }
    }

    const channelName = pagename.replace(/[\|\:].*$/,'').replace(/\s/g,'');
    const tagScenario = getTagScenario(req.document_data && req.document_data.documents_requested && req.document_data.documents_requested[0].documents_requested_options_desc);

    if ((!globals.event51Sent)) {
        // widget start event
        globals.initOmnProducts = ';' + market + ':' + customerType + ':' + pmc +
            ',;' + market + ':Widget:GI' +
            ',;' + market + ':Widget:GI:' + tagScenario;
        globals.initOmnPagename = channelName;
    } else {
        if (opts.selfServiceStart) {
            opts.noRepeat = true;
        } else {
            // Doc Upload Success / Capability Completion Page
            const m = /(.+):Success$/.exec(pagename);
            if (m) {
                opts.noRepeat = true;
            }
        }
    }
    return {
        pagename: getPageName(events, pagename),
        hierarchy: getInitHierarchy(),
        events: events,
        language: utils.getLanguage(flow.config ? flow.config.invoker_locale: 'en'),
        newpagename: "yes",
        pcnnumber: (req && req.document_data) ? req.document_data.process_control_number: '',
        products: getProducts(),
        tools: getTools(bankName),
        widgetID: getId(),
    };
}

const createDTMObject = (currentPage, opts = {}) => {
  const { noRepeat, selfServiceStart, events, successStatus, bankName } = opts;
  const req = getReq();

  return {
    pagename: getPageName(events, currentPage),
    hierarchy: dtm.getDtmHierarchy(getMarket()),
    events: events,
    language: utils.getLanguage(flow.config ? flow.config.invoker_locale: 'en'),
    newpagename: "yes",
    pcnnumber: (req && req.document_data) ? req.document_data.process_control_number : '',
    products: getProducts(),
    tools: getTools(bankName, successStatus),
    id: getId()
  };
}

const createOneAmexDDLObject = (currentPage, opts = {}) => {
  const { events, bankName } = opts;
  const req = getReq();

  return {
    element: 'track_journey_step',
    meta: {
      step: {
        id: getPageName(events, currentPage),
      },
      conversionStep: getConversionStep(events),
      journey: 'widgetapplication',
      pcn: (req && req.document_data) ? req.document_data.process_control_number : '',
      widgetID: getId(),
      tools: getTools(bankName),
      products: {
        id: getPmc(),
        description: 'GI Widget',
        type: 'widget',
        lineOfBusiness: getBusinessUnit(),
        paymentType: 'lending',
        currencyCode: getCurrencyCode(),
        locale: getLocale()
      }
    }
  }
}

export const makeTagObject = (pagename, opts) => {
  const updatedPageName = pagename.replace('AddFile', 'DocUpload');
  //Ensure track method is set properly, some cases allow for delayed availability of tracking libraries
  updateTrackMethod();
  switch(trackMethod) {
    case ONE_AMEX_DDL:
    case ONE_APP_DDL_TRACKING:
      return createOneAmexDDLObject(updatedPageName, opts);
    case DTM:
      return createDTMObject(updatedPageName, opts);
    case ITAG:
      return createOMNObject(updatedPageName, opts);
    default:
      return {};
  }
}

function isRepeated(newOmn, opts){
    if(typeof (globals.trackedPages) === 'undefined'){
        globals.trackedPages = {};
    }
    const trackedPages = globals.trackedPages;
    const key = newOmn.pagename || get(newOmn, 'meta.step.id');
    const hasBeenTracked = !!trackedPages[key];
    trackedPages[key] = true;
    // don't repeat for initialing pages
    if(opts && opts.noRepeat){
        return hasBeenTracked;
    }
    return false;
}

function getTagScenario(weneedcodes){
    var useCaseId = (weneedcodes||'').replace(/[\(\)\s]/g,'').replace(/[\&\|]/g, '-');
    return _n(useCaseId.toLowerCase() + '.tag_scenario') || useCaseId;
}

export function track(pagename, opts = {}){
    const newOmn = makeTagObject(pagename, opts);
    if(!isRepeated(newOmn, opts)){
      lastOmn = extend({}, newOmn); // save a copy

      if (trackMethod === ITAG) {
        omnitureTrack(newOmn);
      }
      else if (trackMethod === DTM) {
        dtm.dtmTrack(newOmn, opts && opts.isAction? "widgetAction": "widgetView");
      }
      else if (trackMethod === ONE_AMEX_DDL) {
        const { element, meta } = newOmn;

        get(flow, 'widgetConfig.analytics.analyticsImpression')({
          element,
          meta,
        });
      }
      else if (trackMethod === ONE_APP_DDL_TRACKING) {
        const { element, meta } = newOmn;
      
        get(flow, 'widgetConfig.analytics_ddl_callback')({
          element,
          meta,
        });
      }
      else {
        console.log(`Tried to track journey event ${pagename}, but no tracking library found`);
      }
    }

    if (opts.events === SUCCESSFUL_FIRST_LOAD_EVENT) {
      globals.event51Sent = true;
    }
}

export function trackError(errorKey){
  const errorString = `${getMarket()}:Widget:GI:Error:${mapErrorKeyToErrorTag(errorKey)}`;

  try{
      if(trackMethod === ITAG && typeof(omn_rmsiteerror) === 'function') {
        const savedOmn = window.omn;
        // use the last tracked page as default
        window.omn = extend({}, savedOmn, lastOmn);
        omn_rmsiteerror(errorString);

        return window.omn = savedOmn;
      }

      if(trackMethod === DTM){
        return dtm.dtmTrack({
          pagename : lastOmn? lastOmn.pagename : 'Widget:GI:Error',
          hierarchy: lastOmn? lastOmn.hierarchy: getMarket() + "|AMEX|Widget|GI",
          error    : errorString
        }, "widgetError");
      }

      if(trackMethod === ONE_AMEX_DDL) {
        return get(flow, 'widgetConfig.analytics.analyticsImpression')({
          element: 'Error',
          detail: errorString,
        });
      }

      if(trackMethod === ONE_APP_DDL_TRACKING) {
        return get(flow, 'widgetConfig.analytics_ddl_callback')({
          element: 'Error',
          detail: errorString,
        });
      }

      return console.log(`Tried to track error ${errorKey}, but no tracking library found`);
  }catch(err){
    console.error(err);
  }
}

export function trackClick(eventName, vars){
  if(trackMethod === ITAG){
    return omnAction(lastOmn ? lastOmn.pagename : getMarket() + '|AMEX|Widget|GI', eventName, vars);
  }

  if(trackMethod === DTM || trackMethod === ITAG){
    eventName = eventName.replace(/^Click_/, '');

    return dtm.dtmTrack({
        pagename : lastOmn ? lastOmn.pagename : 'Error',
        hierarchy: lastOmn ? lastOmn.hierarchy : getMarket() + "|AMEX|Widget|GI",
        products : lastOmn ? lastOmn.products : globals.initOmnProducts,
        pcnnumber: lastOmn ? lastOmn.pcnnumber : (req && req.document_data) ? req.document_data.process_control_number: '',
        eventAction: "Click",
        eventAsset : eventName
    }, 'widgetAction');
  }

  if (trackMethod === ONE_AMEX_DDL) {
    const newEventName = eventName.replace(/^Click_/, '');
    return get(flow, 'widgetConfig.analytics.analyticsClick')({
      element: newEventName,
      detail: newEventName
    });
  }

  if (trackMethod === ONE_APP_DDL_TRACKING) {
    const newEventName = eventName.replace(/^Click_/, '');
    return get(flow, 'widgetConfig.analytics_ddl_callback')({
      element: newEventName,
      detail: newEventName
    });
  }
  
  return console.log(`Tried to track click event ${eventName}, but no tracking library found`);
}

export function trackExit(){
    trackClick('YesExit');
}

export function omnAction(arg1, arg2, vars){
    try{
        if(typeof omn_rmaction === 'function'){
            const savedOmn = window.omn;
            // use the last tracked page as default
            window.omn = extend({}, savedOmn, lastOmn);

            if(typeof vars==='object' && vars){
                for(let k in vars){
                    if(vars.hasOwnProperty(k)){
                        omn_rmvar(k, vars[k]);
                    }
                }
            }

            omn_rmaction(arg1, arg2);

            window.omn = savedOmn;
        }
    }catch(err){
        console.error(err);
    }
}



// WEBPACK FOOTER //
// ./application/src/utilities/track.js